import React, { useMemo } from "react";
import { useState } from "react";
import { IconButton } from "@mui/material";
import moment from "moment";

export default function ShiftEvent({ shift, index, onDeleteShift, onEditPlan }) {

  const [hovering, setHovering] = useState(false);

  const isDisabled = useMemo(() => {
    return shift.resourcing_status && shift.resourcing_status.toString().toLowerCase() === "cancelled"
  }, [shift])

  return (
    <div
      onClick={(e) => { e.stopPropagation() }}
      className="ShiftTaskEvent"
      onMouseEnter={() => { setHovering(true) }}
      onMouseLeave={() => { setHovering(false) }}
      style={{
        width: `${(shift.duration * 80)}px`,
        cursor: isDisabled ? "not-allowed" : "pointer",
        top: `${(index) * 25}px`,
        left: "0px",
        borderColor: isDisabled ? "#ccc" : hovering ? "#000" : "#e2e2e2",
        background: isDisabled ? "#ccc" : "#c0b4ff",
        position: "absolute",
        zIndex: hovering ? 999 : `${20 + index}`,
        height: "20px",
        boxSizing: "border-box",
        padding: "0px 5px",
        border: "1px solid #e2e2e2",
        maxWidth: `${(25 * 80)}px`
      }}>
      <div className="ShiftTaskEventName">
        {(!shift.shift_status || (shift.shift_status && shift.shift_status < 4)) ? (<div>
          {shift.shift_plan ? (
            <IconButton disabled={isDisabled} style={{ height: "auto", padding: "0px", marginRight: "5px", marginTop: "-1px" }} onClick={() => onEditPlan(shift.shift_plan)}>
              <svg style={{ height: "12px" }} fill={isDisabled ? "#999" : "#b4ff00"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
              </svg>
            </IconButton>
          ) : null}
          <IconButton disabled={isDisabled} style={{ height: "auto", padding: "0px", marginRight: "5px", marginTop: "-1px" }} onClick={(e) => { e.stopPropagation(); if (!isDisabled) { onDeleteShift(shift) } }}>
            <svg style={{ height: "12px" }} fill={isDisabled ? "#999" : "#ff0000"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
            </svg>
          </IconButton>
        </div>) : ""}
        <div>{moment(shift.start_date).format("DD/MM")} {shift.start_time} - {moment(shift.end_date).format("DD/MM")} {shift.end_time}</div>
        {/* <div style={{ padding: "0px 5px", color: "#fff" }}>
          <IconButton style={{ height: "auto", padding: "0px", marginRight: "5px", marginTop: "-1px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 340" style={{ width: "1em" }}>
              <path d="M238.34,109A66.49,66.49,0,1,1,171.85,42.5,66.48,66.48,0,0,1,238.34,109Z" style={{ fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLineJoin: "round", strokeWidth: "1em" }} />
              <path d="M49.82,297.5a122,122,0,0,1,244.07,0" style={{ fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLineJoin: "round", strokeWidth: "1em" }} />
              <polygon points="375.99 78.93 402.62 132.9 462.18 141.55 419.09 183.55 429.25 242.86 375.99 214.86 322.74 242.86 332.9 183.55 289.82 141.55 349.36 132.9 375.99 78.93" style={{ fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLineJoin: "round", strokeWidth: "1em" }} />
            </svg>
          </IconButton>
          {shift.supervisors}
        </div> */}
        <div>
          <IconButton style={{ height: "auto", padding: "0px", marginRight: "0px", marginTop: "-1px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 340" style={{ width: "1em" }}>
              <path d="M322.48,109A66.48,66.48,0,1,1,256,42.5,66.47,66.47,0,0,1,322.48,109Z" style={{ fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLineJoin: "round", strokeWidth: "1em" }} />
              <path d="M134,297.5a122,122,0,0,1,244.08,0" style={{ fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1em" }} />
            </svg>
          </IconButton>
          {shift.staffs}
        </div>
        {shift.start_date !== shift.end_date ? (
          <div style={{
            fontSize: "20px",
            lineHeight: "1",
            paddingBottom: "10px",
            paddingLeft: "10px",
            letterSpacing: "2px"
          }}>...</div>
        ) : null}
      </div>
    </div>);
}

